/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Try_AgainInputs */

const de_commons_error_page_try_again = /** @type {(inputs: Commons_Error_Page_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

/** @type {(inputs: Commons_Error_Page_Try_AgainInputs) => LocalizedString} */
const en_commons_error_page_try_again = de_commons_error_page_try_again;

/**

* @param {Commons_Error_Page_Try_AgainInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_try_again = /** @type {((inputs?: Commons_Error_Page_Try_AgainInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Try_AgainInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_try_again(inputs)
	return en_commons_error_page_try_again(inputs)
});